import Cookies from 'js-cookie'
import zionDebug, { printDeprecationWarning } from '@fs/zion-debug'
import { isLoggedIn } from '@fs/zion-config'

const debug = zionDebug('zion:session:index')

export function clearSessionIdCache() {
  printDeprecationWarning(
    'There is no longer a sessionId cache in zion-session, `clearSessionIdCache()` is deprecated and a no-op and will be removed in the next major version'
  )
}

export function getSessionId() {
  // caching the sessionId in memory seems to cause issues with cross-tab behavior, so do not cache this, always read it fresh from the cookie
  return Cookies.get('fssessionid')
}

export const sessionTypes = {
  unknown: 'UNKNOWN',
  noSession: 'NO_SESSION',
  anonymousSession: 'ANONYMOUS_SESSION',
  userSession: 'USER_SESSION',
}
export function getSessionType() {
  const windowDefined = typeof window !== 'undefined'
  debug('getSessionType', { windowDefined, isLoggedIn })
  if (!windowDefined || typeof isLoggedIn === 'undefined') return sessionTypes.unknown
  if (!getSessionId()) return sessionTypes.noSession
  if (isLoggedIn) return sessionTypes.userSession
  return sessionTypes.anonymousSession
}

export class NoUserSessionError extends Error {
  constructor(message) {
    super(message)
    this.name = 'NoUserSessionError'
  }
}
export class NoSessionError extends Error {
  constructor(message) {
    super(message)
    this.name = 'NoSessionError'
  }
}
export function validUserSessionOrError() {
  const sessionType = getSessionType()
  if (
    sessionType === sessionTypes.noSession ||
    sessionType === sessionTypes.anonymousSession ||
    (sessionType === sessionTypes.unknown && !getSessionId())
  ) {
    throw new NoUserSessionError('No User Session Id')
  }
}
export function validAnonSessionOrError() {
  const sessionType = getSessionType()
  if (sessionType === sessionTypes.noSession || (sessionType === sessionTypes.unknown && !getSessionId())) {
    throw new NoSessionError('No Session Id')
  }
}

export function extractCorrelationId(fullSessionId) {
  // https://icseng.atlassian.net/wiki/spaces/Product/pages/133597684/Session+ID+Format
  return fullSessionId?.split('.')[0]
}

export function getCorrelationId() {
  return extractCorrelationId(getSessionId())
}

// Re-export useful functions
export { getSession, getNewAnonSession, getAnonSession } from './fetch'
export { clearCachedSession } from './cache'
